export const CONNECT = 'connect';
export const SUBSCRIBE = 'user:subscribeByAccessToken';
export const GRADE_EXPORT_START = 'GradeExport:START';
export const GRADE_EXPORT_DONE = 'GradeExport:DONE';
export const GRADE_EXPORT_FAILED = 'GradeExport:FAILED';
export const ASSIGNMENT_GRADED = 'Assignment:Graded';
export const ASSIGNMENT_SUBMITTED = 'Assignment:Submitted';
